import React from 'react';

interface UploadOverlayProps {
  isVisible: boolean;
  progress: number;
}

const UploadOverlay: React.FC<UploadOverlayProps> = ({ isVisible, progress }) => {
  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-white/90 dark:bg-gray-900/90 backdrop-blur-sm transition-all duration-300">
      <div className="max-w-md w-full p-8 rounded-2xl bg-white dark:bg-gray-800 shadow-xl border border-gray-200 dark:border-gray-700">
        <div className="flex flex-col items-center">
          <img src="./logo.svg" className="w-20 h-20 mb-4" alt="Logo" />
          <h2 className="text-2xl font-bold mb-2 text-gray-900 dark:text-white">Uploading Image</h2>
          <p className="text-gray-600 dark:text-gray-300 text-center mb-6">
            Please wait while we upload and process your image. This may take a moment...
          </p>
          
          <div className="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-3 mb-2">
            <div 
              className="h-3 rounded-full transition-all duration-300 bg-blue-500 dark:bg-blue-600"
              style={{ width: `${progress}%` }}
            ></div>
          </div>
          
          <p className="text-sm text-blue-600 dark:text-blue-400">{Math.round(progress)}%</p>
          
          <div className="mt-6 text-sm text-gray-500 dark:text-gray-400">
            We'll automatically continue when the upload is complete
          </div>
        </div>
      </div>
    </div>
  );
};

export default UploadOverlay;